import { CellMixin } from '/@/modules/core/table/mixins/CellMixin';
import { TableRenderService } from '/@/modules/core/table/services/TableRenderService';
import { BaseListService } from '/@/modules/core/table/services/BaseListService';

export const ActionCellMixin = {
  props: {
    ...CellMixin.props,
    dtColumns: Object,
    renderService: TableRenderService,
    dataService: BaseListService,
    tableId: String,
    primaryKeyField: String,
    primaryNameField: String
  }
};
